import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import SearchableSelect from "../SearchableSelect";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";

function AddCharges({ toggle, close, consumableItemData, edit }) {
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [customForm, setCustomForm] = useState({
    categoryName: "",
    accessoryType: {},
    city: {},
    averageWeight: "",
    intercityCharges: "",
    intracityCharges: "",
    alpha: "",
    alpha_accessory_override: "",
  });
  const [cities, setCities] = useState([]);
  const [accessoryTypes, setAccessoryTypes] = useState([]);

  const fetchAllCharges = useApi(api.getCitiess);
  const fetchAllAccessoryTypes = useApi(api.fetchAllAccessoryTypes);
  const saveCharges = useApi(postapi.addChargesForCity, { hasCatchError: true });
  const updateCharges = useApi(postapi.updateChargesForCity, { hasCatchError: true });
  const categories = [
    {
      value: "2",
      label: "Mobile",
    },
    { value: "3", label: "Tablet" },
    { value: "4", label: "TV / Monitor" },

    { value: "1", label: "Laptop" },
    { value: "5", label: "Desktop Computer" },
    { value: "6", label: "Accessories" },
  ];
  const handleChange = (e) => {
    setCustomForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidated(true);
    let obj = {
      city_id: customForm.city.value,
      city_name: customForm.city.label,
      category_id: Number(customForm.categoryName.value),
      category_name: customForm.categoryName.label,
      accessory_type: customForm.categoryName.label === "Accessories" ? customForm.accessoryType.label : "",
      accessory_type_id: customForm.categoryName.label === "Accessories" ? customForm.accessoryType.value : null,
      average_weight: customForm?.averageWeight || null,
      inter_city_charges: customForm.intercityCharges,
      intra_city_charges: customForm.intracityCharges,
      alpha: customForm.alpha,
      alpha_accessory_override: customForm.alpha_accessory_override,
    };
    try {
      let res;
      if (edit) {
        res = await updateCharges.request(obj, consumableItemData?.id);
      } else {
        res = await saveCharges.request(obj);
      }
      setValidated(false);
      setCustomForm({
        categoryName: "",
        accessoryType: {},
        city: {},
        averageWeight: "",
        intercityCharges: "",
        intracityCharges: "",
        alpha: "",
        alpha_accessory_override: "",
      });
      toggle((prev) => !prev);
      close();
      setError("");
    } catch (error) {
      setError(error.response.data.error);
    }
  };
  const handleSelectChange = (e, name) => {
    setCustomForm((prev) => ({ ...prev, [name]: e }));
  };
  const getAllCities = async () => {
    try {
      let data = await fetchAllCharges.request();
      setCities(data?.data?.map((item) => ({ label: item.city_name, value: item.city_id })));
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const getAllAccessoryTypes = async () => {
    try {
      let res = await fetchAllAccessoryTypes.request();
      setAccessoryTypes(res?.data?.data?.map((item) => ({ label: item.label, value: item.id })));
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  useEffect(() => {
    getAllCities();

    if (edit) {
      setCustomForm({
        categoryName: {
          value: consumableItemData?.category_id,
          label: consumableItemData?.category_name,
        },
        accessoryType: {
          value: consumableItemData?.accessory_type_id,
          label: consumableItemData?.accessory_type,
        },
        city: {
          value: consumableItemData?.city_id,
          label: consumableItemData?.city_name,
        },
        averageWeight: consumableItemData?.average_weight,
        intercityCharges: consumableItemData?.inter_city_charges,
        intracityCharges: consumableItemData?.intra_city_charges,
        alpha: consumableItemData?.alpha,
        alpha_accessory_override: consumableItemData?.alpha_accessory_override,
      });
    } else {
      setCustomForm({
        categoryName: "",
        accessoryType: {},
        city: {},
        averageWeight: "",
        intercityCharges: "",
        intracityCharges: "",
        alpha: "",
        alpha_accessory_override: "",
      });
    }
  }, [edit]);
  useEffect(() => {
    if (customForm.categoryName.label === "Accessories") {
      getAllAccessoryTypes();
    }
  }, [customForm.categoryName]);
  return (
    <div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        {error && <span className="text-danger p-2 text-center my-2 rounded-1">*{error}</span>}

        <Row className="">
          <Col className="py-3" md={6}>
            <Form.Group>
              <SearchableSelect placeholder="Select" label="categoryName " important={true} value={customForm.categoryName} searchable={false} options={categories} handleChange={(e) => handleSelectChange(e, "categoryName")} disabled={edit} />
              <Form.Control value={customForm?.categoryName} onChange={() => {}} hidden required />
              <Form.Control.Feedback type="invalid">Please select Category.</Form.Control.Feedback>
            </Form.Group>
          </Col>
          {customForm.categoryName.label === "Accessories" ? (
            <Col className="py-3" md={6}>
              <Form.Group>
                <SearchableSelect placeholder="Select" label="accessoryType " value={customForm.accessoryType} searchable={true} options={accessoryTypes} handleChange={(e) => handleSelectChange(e, "accessoryType")} disabled={edit} />
                <Form.Control value={customForm?.accessoryType} onChange={() => {}} hidden required />
                <Form.Control.Feedback type="invalid">Please select Accessory Type.</Form.Control.Feedback>
              </Form.Group>
            </Col>
          ) : (
            <></>
          )}

          <Col className="py-3" md={6}>
            <Form.Group>
              <SearchableSelect placeholder="Select" label="City " important={true} value={customForm.city} searchable={false} options={cities} handleChange={(e) => handleSelectChange(e, "city")} disabled={edit} />
              <Form.Control value={customForm?.city} onChange={() => {}} hidden required />
              <Form.Control.Feedback type="invalid">Please Select City.</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col className="py-2" lg="6">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="mb-1">
                Average Weight(in kg) <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 5) {
                    handleChange(e);
                  }
                }}
                placeholder="Enter Average Weight"
                name="averageWeight"
                value={customForm.averageWeight}
              />
            </Form.Group>
          </Col>
          <Col className="py-2" lg="6">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="mb-1">
                InterCity Charges <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 5) {
                    handleChange(e);
                  }
                }}
                placeholder="Enter Charges"
                name="intercityCharges"
                value={customForm.intercityCharges}
              />
            </Form.Group>
          </Col>
          <Col className="py-2" lg="6">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="mb-1">
                IntraCity Charges <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 5) {
                    handleChange(e);
                  }
                }}
                placeholder="Enter Charges"
                name="intracityCharges"
                value={customForm.intracityCharges}
              />
            </Form.Group>
          </Col>
          <Col className="py-2" lg="6">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="mb-1">Alpha</Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 5) {
                    handleChange(e);
                  }
                }}
                placeholder="Enter Alpha"
                name="alpha"
                value={customForm.alpha}
              />
            </Form.Group>
          </Col>
          <Col className="py-2" lg="6">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="mb-1">Alpha Accessory Override</Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 5) {
                    handleChange(e);
                  }
                }}
                placeholder="Enter Alpha Accessory Override"
                name="alpha_accessory_override"
                value={customForm.alpha_accessory_override}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="py-3">
          <Col>
            <Button type="submit" className="w-100">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default AddCharges;
